export { default } from './circled-image';
